<template>
  <v-container
    id="data-tables"
    tag="section"
  >
     <UsersForm
        :show="show"
        :user="form"
        title="Профиль"
        @save="save"
        :profile="true"
      />
      <clients-form
      v-if="form.client"
      :id="form.client"
      :create="false"
      :view="false"
      :change="true"
      :profile="true"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
  import UsersForm from './UsersForm.vue'
  export default {
    components: { UsersForm },
    name: 'Profile',
    data () {
      return {
        show: false,
        form: {
          phone: '',
          valid: false,
          surname: '',
          name: '',
          patronymic: '',
          role: '',
        },
        client: null,
        select: {
          role: [],
        },
      }
    },
    mounted: function () {
      this.show = true
      for (let x in this.$store.state.dict.role) {
        this.select.role.push({ value: Number(x), text: this.$store.state.dict.role[x].name })
      }
      this.form = JSON.parse(JSON.stringify(this.$store.state.user))
    },
    beforeRouteUpdate (to, from, next) {
      this.show = true
      next()
    },
    beforeRouteLeave(to, from, next) {
      this.show = false
      next()
    },
    methods: {
      save: function (data) {
        this.form = data
        this.form.id = this.$store.state.user.id
        this.axios.post('/api/user/save/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно сохранены')
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
    },
  }
</script>
